export default {
  FETCH_UPCOMING_APPOINTMENTS_DATA: "FETCH_UPCOMING_APPOINTMENTS_DATA",
  FETCH_UPCOMING_APPOINTMENTS_DATA_SUCCESS:
    "FETCH_UPCOMING_APPOINTMENTS_DATA_SUCCESS",
  FETCH_UPCOMING_APPOINTMENTS_DATA_ERROR:
    "FETCH_UPCOMING_APPOINTMENTS_DATA_ERROR",
};
